export default {"src":"/_next/static/media/debate.3ba09446.svg","height":604,"width":938};